import * as React from 'react';
import styled from 'styled-components';
import {
  IComparedWeight,
  IWeightReportState,
} from '../../../data/providers/reports/weightReportProvider';
import { Entity } from '../../../data/types';
import { Column } from '../../layout/Column';
import { Row } from '../../layout/Row';
import { Card } from '../../shared/card/Card';
import { CardBody } from '../../shared/card/CardBody';
import { CardHeader } from '../../shared/card/CardHeader';
import { ListHeader } from '../../shared/List/ListHeader';
import { EPdfMode, shouldInvert } from '../../shared/pdf/Pdf';
import { WeightResult } from './WeightResult';

interface IProps {
  reportState: IWeightReportState;
  colors: string[];
  pdfMode: EPdfMode;
  entity: Entity;
}
export const ResultList = (props: IProps): React.ReactElement => {
  const listShape = [0.5, 1, 1, 1, 1, 1];
  return (
    <Row>
      <Container>
        <Card
          style={{ marginTop: 'var(--grid-gap)' }}
          inverse={shouldInvert(props.pdfMode)}
        >
          <Column>
            <CardHeader surface={24} withListHeader>
              <Column>
                <ListHeader
                  leftAlignLastCell
                  shape={listShape}
                  labels={[
                    '',
                    'Athlete',
                    'Mean',
                    'Baseline Mean',
                    'Change',
                    'Change %',
                  ]}
                />
              </Column>
            </CardHeader>
            <CardBody>
              {props.reportState.data.map(
                (
                  result: IComparedWeight,
                  index: number
                ): React.ReactElement => {
                  return (
                    <WeightResult
                      result={result}
                      key={index}
                      color={props.colors[index % 2]}
                      pdfMode={props.pdfMode}
                      entity={props.entity}
                      rank={index + 1}
                      shape={listShape}
                      lowerCutoff={
                        props.reportState?.settings?.changeCutoffs?.lowerCutoff
                      }
                      upperCutoff={
                        props.reportState?.settings?.changeCutoffs?.upperCutoff
                      }
                    />
                  );
                }
              )}
            </CardBody>
          </Column>
        </Card>
      </Container>
    </Row>
  );
};

const Container = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  width: 100%;
  padding-bottom: var(--grid-gap);
`;

interface IMetricLabelProps {
  testMeta: string;
  metricLabel: string;
}

const MetricLabel = (props: IMetricLabelProps): React.ReactElement => {
  return (
    <div>
      <div>{props.testMeta}</div>
      <div>{props.metricLabel}</div>
    </div>
  );
};
